export default __webpack_public_path__ + "static/media/640_dummy2016-sportbekleidung01-de.749783b0.png";